import { render } from "./PreOrderBackerStatus.vue?vue&type=template&id=bc373004"
import script from "./PreOrderBackerStatus.vue?vue&type=script&lang=js"
export * from "./PreOrderBackerStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__